export default __webpack_public_path__ + "locales/es/ConnectDialog.json?hash=92293701be3ca61c4327843135834650";